import { render, staticRenderFns } from "./vcHeaderTitle.vue?vue&type=template&id=328dc113&scoped=true&"
import script from "./vcHeaderTitle.vue?vue&type=script&lang=js&"
export * from "./vcHeaderTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "328dc113",
  null
  
)

export default component.exports